import { render, staticRenderFns } from "./ShapeSvg.vue?vue&type=template&id=8d66b1d6&scoped=true&lang=pug&"
var script = {}
import style0 from "./ShapeSvg.vue?vue&type=style&index=0&id=8d66b1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d66b1d6",
  null
  
)

export default component.exports